import { ButtonViewFormDynamicComponent, UpdateData, InputTableComponent, BaseControl } from '@app/shared';
import { EventEmitter } from '@angular/core';

export class SpecialOptionsConfigService {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // se emite cada vez que se realiza una modificacion desde la columna
  updated: EventEmitter<UpdateData> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor () { }

  /**
   * Retorna la configuracion de la tabla de orden de pestañas
   *
   * @param {BaseControl<any>[]} controlsOrder
   * @param {BaseControl<any>[]} controlsRequired
   * @param {BaseControl<any>[]} controlsTitle
   * @memberof SpecialOptionsConfigService
   */
  getConfigTable(
    controlsOrder: BaseControl<any>[],
    controlsRequired: BaseControl<any>[],
    controlsTitle: BaseControl<any>[]
  ) {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'Actualmente no hay pestañas',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        orden: {
          editable: false,
          addable: false,
          title: 'Orden',
          filter: {
            inputClass: 'form-control',
          },
          type: 'custom',
          renderComponent: InputTableComponent,
          onComponentInitFunction(instance: InputTableComponent) {
            instance.dynamicTable = false;
            instance.controls = controlsOrder;
            instance.dataUpdate.subscribe((data: UpdateData) => self.updated.emit(data));
          }
        },
        pestana: {
          editable: false,
          addable: false,
          title: 'Pestaña',
          filter: {
            inputClass: 'form-control',
          },
        },
        nombre: {
          editable: false,
          addable: false,
          title: 'Título de la pestaña',
          filter: {
            inputClass: 'form-control',
          },
          type: 'custom',
          renderComponent: InputTableComponent,
          onComponentInitFunction(instance: InputTableComponent) {
            instance.dynamicTable = false;
            instance.controls = controlsTitle;
            instance.dataUpdate.subscribe((data: UpdateData) => self.updated.emit(data));
          }
        },
        requerido: {
          editable: false,
          addable: false,
          title: 'Requerido',
          filter: {
            inputClass: 'form-control',
            type: 'checkbox',
            config: {
              true: 'true',
              false: 'flase',
              resetText: 'Limpiar',
            },
          },
          type: 'custom',
          renderComponent: InputTableComponent,
          onComponentInitFunction(instance: InputTableComponent) {
            instance.dynamicTable = false;
            instance.controls = controlsRequired;
            instance.dataUpdate.subscribe((data: UpdateData) => self.updated.emit(data));
          }
        },
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/special-options/shared/special-options.config.service.ts